<!-- eslint-disable max-len -->
<template>
    <div class="inventory-status container">
        <div class="inventory-status__page-header d-flex justify-content-between align-items-center sm-flex-column md-flex-column">
            <div class="d-flex align-items-baseline" style="gap: 10px">
                <h1 class="h1-title" style="font-weight: 500 !important; line-height: 21px">{{ $t('views.inventoryStatus.title') }}</h1>
            </div>
            <div class="d-flex align-items-center sm-flex-column">
                <button
                    v-for="day in daysShortcuts"
                    :key="day"
                    type="button"
                    class="btn btn-link btn-sm p-0"
                    :class="[currentShortcut === day ? 'text-primary' : 'text-secondary']"
                    style="font-size: 14px; font-weight: 400"
                    @click="changeDateShortcut(day)"
                >
                    {{ $t('views.inventoryStatus.daysShortcuts.' + day) }}<span class="mr-05 ml-05" v-if="day !== daysShortcuts[daysShortcuts.length - 1]">/</span>
                </button>
                <!-- <VueDatePicker
                            :model-value="date"
                            @update:model-value="handleDate"
                            locale="tr"
                            range
                            multi-calendars
                            auto-apply
                            :preset-dates="presetDates"
                            :action-row="{ showPreview: false }"
                            :format="datePickerFormat"
                            :enable-time-picker="false"
                            :clearable="false"
                        >
                            <template #input-icon>
                                <i class="bi bi-calendar-week dp__input_icon dp__input_icons" style="margin-top: -4px"></i>
                            </template>
                            <template #preset-date-range-button="{ label, value, presetDate }">
                                <span role="button" :tabindex="0" @click="presetDate(value)" @keyup.enter.prevent="presetDate(value)" @keyup.space.prevent="presetDate(value)">
                                    {{ label }}
                                </span>
                            </template></VueDatePicker
                        > -->
                <DateRangePicker :callback="handleDate" :singleDatePicker="false" :dateData="date_range" openPosition="left" :language="$i18n.locale" />
            </div>
        </div>

        <div v-if="currentMarket.sync_state && syncStates.findIndex((state) => state === 'FEE_REPORT_COMPLETED') > syncStates.findIndex((state) => state === currentMarket.sync_state) && currentMarket.status === 1" class="text-muted">
            {{ $t('views.inventoryStatus.loadingText') }} <img src="@/assets/extension-loader.gif" height="24" />
        </div>

        <hr style="margin: 0; margin-top: 20px; margin-bottom: 30px" />

        <div class="flex" style="position: relative">
            <InventoryStatusCalculator style="z-index: 10" />

            <div class="card card-hover-shadow mb-5">
                <div class="card-body">
                    <div class="row col-sm-divider">
                        <div class="col">
                            <Popper placement="right" hover arrow :content="$t('views.inventoryStatus.sections.orderQuantity.tooltip')">
                                <h6 class="card-subtitle">{{ $t('views.inventoryStatus.sections.orderQuantity.title') }}</h6>
                            </Popper>

                            <h2 class="card-title text-inherit text-truncate">
                                {{ (+stats.cards?.total_order_count || 0)?.toLocaleString(undefined, { maximumFractionDigits: 2 }) }} {{ $tc('views.inventoryStatus.order', stats.cards?.total_order_count > 1 ? 2 : 1) }}
                            </h2>

                            <div class="d-flex flex-column">
                                <div class="sm-flex-column">
                                    <span class="badge bg-soft-secondary text-secondary" style="font-weight: 400; font-size: 10px !important">
                                        <i :class="getDiffIcon(stats.diff?.total_order_count_diff_rate)"></i> {{ formatPercentage(stats.diff?.total_order_count_diff_rate || 0) }}
                                    </span>
                                    <span class="text-body fs-6 ms-1" style="font-size: 11px !important">{{
                                        $t('views.inventoryStatus.diffInDays', { day: stats.diff?.diff_in_days, dayPlural: this.$tc('views.inventoryStatus.dayPlural', stats.diff?.diff_in_days > 1 ? 2 : 1) })
                                    }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <Popper placement="right" hover arrow :content="$t('views.inventoryStatus.sections.orderAmount.tooltip')">
                                <h6 class="card-subtitle">{{ $t('views.inventoryStatus.sections.orderAmount.title') }}</h6>
                            </Popper>

                            <div class="row align-items-center">
                                <div class="col">
                                    <h2 class="card-title text-inherit text-truncate">{{ getTargetCurrencyFormat(stats.cards?.total_order_amount) }}</h2>

                                    <div class="d-flex flex-column">
                                        <div class="sm-flex-column">
                                            <span class="badge bg-soft-secondary text-secondary" style="font-weight: 400; font-size: 10px !important">
                                                <i :class="getDiffIcon(stats.diff?.total_order_amount_diff_rate)"></i> {{ formatPercentage(stats.diff?.total_order_amount_diff_rate || 0) }}
                                            </span>
                                            <span class="text-body fs-6 ms-1" style="font-size: 11px !important">{{
                                                $tc('views.inventoryStatus.diffInDays', { day: stats.diff?.diff_in_days, dayPlural: this.$tc('views.inventoryStatus.dayPlural', stats.diff?.diff_in_days > 1 ? 2 : 1) })
                                            }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <Popper hover arrow :content="$t('views.inventoryStatus.sections.totalRevenue.tooltip')">
                                <h6 class="card-subtitle">{{ $t('views.inventoryStatus.sections.totalRevenue.title') }}</h6>
                            </Popper>

                            <div class="row align-items-center">
                                <div class="col-12">
                                    <h2 class="card-title text-inherit text-truncate">{{ getTargetCurrencyFormat(stats.cards?.total_revenue) }}</h2>

                                    <div class="d-flex flex-column">
                                        <div>
                                            <span class="badge bg-soft-secondary text-secondary" style="font-weight: 400; font-size: 10px !important; white-space: nowrap">
                                                <i :class="getDiffIcon(stats.diff?.total_revenue_diff_rate)"></i> {{ formatPercentage(stats.diff?.total_revenue_diff_rate || 0) }}
                                            </span>
                                            <span class="text-body fs-6 ms-1" style="font-size: 11px !important">{{
                                                $t('views.inventoryStatus.diffInDays', { day: stats.diff?.diff_in_days, dayPlural: this.$tc('views.inventoryStatus.dayPlural', stats.diff?.diff_in_days > 1 ? 2 : 1) })
                                            }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <Popper hover arrow :content="$t('views.inventoryStatus.sections.cog.tooltip')">
                                <h6 class="card-subtitle">{{ $t('views.inventoryStatus.sections.cog.title') }}</h6>
                            </Popper>

                            <div class="row align-items-center">
                                <div class="col-12">
                                    <h2 class="card-title text-inherit text-truncate">{{ getTargetCurrencyFormat(stats.cards?.total_cog) }}</h2>

                                    <div class="d-flex flex-column">
                                        <div>
                                            <span class="badge bg-soft-secondary text-secondary" style="font-weight: 400; font-size: 10px !important; white-space: nowrap">
                                                <i :class="getDiffIcon(stats.diff?.total_cog_diff_rate)"></i> {{ formatPercentage(stats.diff?.total_cog_diff_rate || 0) }}
                                            </span>
                                            <span class="text-body fs-6 ms-1" style="font-size: 11px !important">{{
                                                $t('views.inventoryStatus.diffInDays', { day: stats.diff?.diff_in_days, dayPlural: this.$tc('views.inventoryStatus.dayPlural', stats.diff?.diff_in_days > 1 ? 2 : 1) })
                                            }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <Popper hover arrow :content="$t('views.inventoryStatus.sections.profit.tooltip')">
                                <h6 class="card-subtitle">{{ $t('views.inventoryStatus.sections.profit.title') }}</h6>
                            </Popper>

                            <h2 class="card-title text-inherit" style="white-space: nowrap">{{ getTargetCurrencyFormat(stats.cards?.total_profit) }}</h2>

                            <span class="badge bg-soft-secondary text-secondary" style="font-weight: 400; font-size: 10px !important">
                                <i :class="getDiffIcon(stats.diff?.total_profit_diff_rate)"></i> {{ formatPercentage(stats.diff?.total_profit_diff_rate || 0) }}
                            </span>
                        </div>
                        <div class="col">
                            <Popper hover arrow :content="$t('views.inventoryStatus.sections.roi.tooltip')">
                                <h6 class="card-subtitle">{{ $t('views.inventoryStatus.sections.roi.title') }}</h6>
                            </Popper>

                            <h2 class="card-title text-inherit" style="white-space: nowrap">{{ formatPercentage(stats.cards?.total_roi ? stats.cards?.total_roi : 0) }}</h2>

                            <div class="d-flex flex-column">
                                <div>
                                    <span class="badge bg-soft-secondary text-secondary" style="font-weight: 400; font-size: 10px !important">
                                        <i :class="getDiffIcon(stats.diff?.total_roi_diff_rate)"></i> {{ formatPercentage(stats.diff?.total_roi_diff_rate || 0) }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <Popper hover arrow :content="$t('views.inventoryStatus.sections.activeProductCount.tooltip')">
                                <h6 class="card-subtitle">{{ $t('views.inventoryStatus.sections.activeProductCount.title') }}</h6>
                            </Popper>

                            <div class="d-flex flex-column">
                                <div class="d-flex align-items-center" style="gap: 5px">
                                    <h2 class="card-title text-inherit" style="white-space: nowrap">
                                        {{ (+stats.cards?.total_active || 0)?.toLocaleString(undefined, { maximumFractionDigits: 2 }) }} {{ $tc('views.inventoryStatus.amount', +stats.cards?.total_active > 0 ? 2 : 1) }}
                                    </h2>
                                    <span class="badge bg-success text-white" style="font-weight: 400; font-size: 10px !important; margin-bottom: 10px">{{ $t('views.inventoryStatus.active') }}</span>
                                </div>

                                <div class="d-flex align-items-center" style="gap: 5px">
                                    <h2 class="card-title text-inherit" style="white-space: nowrap">
                                        {{ (+stats.cards?.total_inactive || 0)?.toLocaleString(undefined, { maximumFractionDigits: 2 }) }} {{ $tc('views.inventoryStatus.amount', +stats.cards?.total_inactive > 0 ? 2 : 1) }}
                                    </h2>
                                    <span class="badge bg-danger text-white" style="font-weight: 400; font-size: 10px !important; margin-bottom: 10px">{{ $t('views.inventoryStatus.inactive') }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mb-5 grid-gap-2">
            <div class="col-xs-16 col-lg-9 sm-mb-5">
                <div class="card">
                    <div class="card-header" style="height: 79px">
                        <div class="d-flex align-items-center justify-content-between">
                            <span style="font-weight: 500; font-size: 15px">{{ $t('views.inventoryStatus.orderChart.title') }}</span>
                            <ul class="nav nav-segment d-flex" role="tablist">
                                <li class="nav-item">
                                    <a class="nav-link active" id="column-tab" href="#column" data-bs-toggle="pill" data-bs-target="#column" role="tab" aria-controls="column" aria-selected="true" style="color: #1e2022">{{
                                        $t('views.inventoryStatus.orderChart.column')
                                    }}</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" id="line-tab" href="#line" data-bs-toggle="pill" data-bs-target="#line" role="tab" aria-controls="line" aria-selected="true" style="color: #1e2022">{{
                                        $t('views.inventoryStatus.orderChart.line')
                                    }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="card-body" style="padding-top: 19px; padding-bottom: 19px">
                        <div class="tab-content" style="margin-top: 10px">
                            <div class="tab-pane fade show active" id="column" role="tabpanel" aria-labelledby="column-tab">
                                <ChartBar :key="`column_${chartBarKey}`" :data="chartBarData" :options="chartBarOptions" style="height: 328px; width: 100%" />
                            </div>
                            <div class="tab-pane fade" id="line" role="tabpanel" aria-labelledby="line-tab">
                                <ChartLine :key="`line_${chartBarKey}`" :data="chartBarData" :options="chartBarOptions" style="height: 328px; width: 100%" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-16 col-lg-3">
                <div class="card">
                    <div class="card-header d-flex align-items-center" style="height: 79px; font-weight: 500; font-size: 15px">{{ $t('views.inventoryStatus.inventorySummary.title') }}</div>
                    <div class="card-body status-summary-row">
                        <div class="row g-2 justify-content-center">
                            <div class="col-xs-16 col-lg-6 summary-line-border">
                                <div class="d-flex flex-column align-items-end" style="gap: 5px; padding: 12.5px 15px 12.5px 15px">
                                    <div class="d-flex" style="gap: 5px; white-space: nowrap">
                                        <Popper hover arrow style="margin: 0; border: 0">
                                            <template #content>
                                                <div>{{ $t('views.inventoryStatus.inventorySummary.tooltip.sellable') }} {{ getTargetCurrencyFormat(stats.expected?.quantity?.sellable) }}</div>
                                                <div>{{ $t('views.inventoryStatus.inventorySummary.tooltip.inbound') }} {{ getTargetCurrencyFormat(stats.expected?.quantity?.inbound) }}</div>
                                                <div>{{ $t('views.inventoryStatus.inventorySummary.tooltip.reserved') }} {{ getTargetCurrencyFormat(stats.expected?.quantity?.reserved) }}</div>
                                            </template>
                                            <span style="font-size: 12px; font-weight: 400; line-height: 21px; color: #677788">{{ $t('views.inventoryStatus.sections.totalQty.title') }}</span>
                                        </Popper>
                                        <InfoTooltip :content="$t('views.inventoryStatus.sections.totalQty.tooltip')" />
                                    </div>
                                    <span class="fs-18" style="font-weight: 700; line-height: 21px; color: #555">{{
                                        stats.expected?.quantity?.total.toLocaleString(undefined, {
                                            maximumFractionDigits: 2,
                                        })
                                    }}</span>
                                </div>
                            </div>
                            <div class="col-xs-16 col-lg-6 summary-line summary-line-border">
                                <div class="d-flex flex-column" style="gap: 5px; padding: 12.5px 15px 12.5px 15px">
                                    <div class="d-flex" style="gap: 5px; white-space: nowrap">
                                        <Popper hover arrow style="margin: 0; border: 0">
                                            <template #content>
                                                <div>{{ $t('views.inventoryStatus.inventorySummary.tooltip.sellable') }} {{ getTargetCurrencyFormat(stats.expected?.cost?.sellable) }}</div>
                                                <div>{{ $t('views.inventoryStatus.inventorySummary.tooltip.inbound') }} {{ getTargetCurrencyFormat(stats.expected?.cost?.inbound) }}</div>
                                                <div>{{ $t('views.inventoryStatus.inventorySummary.tooltip.reserved') }} {{ getTargetCurrencyFormat(stats.expected?.cost?.reserved) }}</div>
                                            </template>
                                            <span style="font-size: 12px; font-weight: 400; line-height: 21px; color: #677788">{{ $t('views.inventoryStatus.sections.cog.title') }}</span>
                                        </Popper>
                                        <InfoTooltip :content="$t('views.inventoryStatus.sections.cog.tooltip')" />
                                    </div>
                                    <span class="fs-18" style="font-weight: 700; line-height: 21px; color: #555; white-space: nowrap">{{ getSourceCurrencyFormat(stats.expected?.cost?.total) }}</span>
                                </div>
                            </div>
                            <div class="col-xs-16 col-lg-6 summary-line-border">
                                <div class="d-flex flex-column align-items-end" style="gap: 5px; padding: 12.5px 15px 12.5px 15px">
                                    <div class="d-flex" style="gap: 5px; white-space: nowrap">
                                        <Popper hover arrow style="margin: 0; border: 0">
                                            <template #content>
                                                <div>{{ $t('views.inventoryStatus.inventorySummary.tooltip.sellable') }} {{ getTargetCurrencyFormat(stats.expected?.stock_value?.sellable) }}</div>
                                                <div>{{ $t('views.inventoryStatus.inventorySummary.tooltip.inbound') }} {{ getTargetCurrencyFormat(stats.expected?.stock_value?.inbound) }}</div>
                                                <div>{{ $t('views.inventoryStatus.inventorySummary.tooltip.reserved') }} {{ getTargetCurrencyFormat(stats.expected?.stock_value?.reserved) }}</div>
                                            </template>
                                            <span style="font-size: 12px; font-weight: 400; line-height: 21px; color: #677788">{{ $t('views.inventoryStatus.sections.stockValue.title') }}</span>
                                        </Popper>
                                        <InfoTooltip :content="$t('views.inventoryStatus.sections.stockValue.tooltip')" />
                                    </div>
                                    <span class="fs-18" style="font-weight: 700; line-height: 21px; color: #555; white-space: nowrap">{{ getTargetCurrencyFormat(stats.expected?.stock_value?.total) }}</span>
                                </div>
                            </div>
                            <div class="col-xs-16 col-lg-6 summary-line summary-line-border">
                                <div class="d-flex flex-column" style="gap: 5px; padding: 12.5px 15px 12.5px 15px">
                                    <div class="d-flex" style="gap: 5px; white-space: nowrap">
                                        <Popper hover arrow style="margin: 0; border: 0">
                                            <template #content>
                                                <div>{{ $t('views.inventoryStatus.inventorySummary.tooltip.sellable') }} {{ getTargetCurrencyFormat(stats.expected?.min_stock_value?.sellable) }}</div>
                                                <div>{{ $t('views.inventoryStatus.inventorySummary.tooltip.inbound') }} {{ getTargetCurrencyFormat(stats.expected?.min_stock_value?.inbound) }}</div>
                                                <div>{{ $t('views.inventoryStatus.inventorySummary.tooltip.reserved') }} {{ getTargetCurrencyFormat(stats.expected?.min_stock_value?.reserved) }}</div>
                                            </template>
                                            <span style="font-size: 12px; font-weight: 400; line-height: 21px; color: #677788">{{ $t('views.inventoryStatus.sections.minStockValue.title') }}</span>
                                        </Popper>
                                        <InfoTooltip :content="$t('views.inventoryStatus.sections.minStockValue.tooltip')" />
                                    </div>
                                    <span class="fs-18" style="font-weight: 700; line-height: 21px; color: #555; white-space: nowrap">{{ getTargetCurrencyFormat(stats.expected?.min_stock_value?.total) }}</span>
                                </div>
                            </div>
                            <div class="col-xs-16 col-lg-6 summary-line-border">
                                <div class="d-flex flex-column align-items-end" style="gap: 5px; padding: 12.5px 15px 12.5px 15px">
                                    <div class="d-flex" style="gap: 5px; white-space: nowrap">
                                        <Popper hover arrow style="margin: 0; border: 0">
                                            <template #content>
                                                <div>{{ $t('views.inventoryStatus.inventorySummary.tooltip.sellable') }} {{ getTargetCurrencyFormat(stats.expected?.expected_revenue?.sellable) }}</div>
                                                <div>{{ $t('views.inventoryStatus.inventorySummary.tooltip.inbound') }} {{ getTargetCurrencyFormat(stats.expected?.expected_revenue?.inbound) }}</div>
                                                <div>{{ $t('views.inventoryStatus.inventorySummary.tooltip.reserved') }} {{ getTargetCurrencyFormat(stats.expected?.expected_revenue?.reserved) }}</div>
                                            </template>
                                            <span style="font-size: 12px; font-weight: 400; line-height: 21px; color: #677788">{{ $t('views.inventoryStatus.sections.expectedPayment.title') }}</span>
                                        </Popper>
                                        <InfoTooltip :content="$t('views.inventoryStatus.sections.expectedPayment.tooltip')" />
                                    </div>
                                    <span class="fs-18" style="font-weight: 700; line-height: 21px; color: #555; white-space: nowrap">{{ getTargetCurrencyFormat(stats.expected?.expected_revenue?.total) }}</span>
                                </div>
                            </div>
                            <div class="col-xs-16 col-lg-6 summary-line summary-line-border">
                                <div class="d-flex flex-column" style="gap: 5px; padding: 10px 0 10px 15px">
                                    <div class="d-flex" style="gap: 5px; white-space: nowrap">
                                        <Popper hover arrow style="margin: 0; border: 0">
                                            <template #content>
                                                <div>{{ $t('views.inventoryStatus.inventorySummary.tooltip.sellable') }} {{ getTargetCurrencyFormat(stats.expected?.min_expected_revenue?.sellable) }}</div>
                                                <div>{{ $t('views.inventoryStatus.inventorySummary.tooltip.inbound') }} {{ getTargetCurrencyFormat(stats.expected?.min_expected_revenue?.inbound) }}</div>
                                                <div>{{ $t('views.inventoryStatus.inventorySummary.tooltip.reserved') }} {{ getTargetCurrencyFormat(stats.expected?.min_expected_revenue?.reserved) }}</div>
                                            </template>
                                            <span style="font-size: 12px; font-weight: 400; line-height: 21px; color: #677788">{{ $t('views.inventoryStatus.sections.minExpectedPayment.title') }}</span>
                                        </Popper>
                                        <InfoTooltip :content="$t('views.inventoryStatus.sections.minExpectedPayment.tooltip')" />
                                    </div>
                                    <span class="fs-18" style="font-weight: 700; line-height: 21px; color: #555; white-space: nowrap">{{ getTargetCurrencyFormat(stats.expected?.min_expected_revenue?.total) }}</span>
                                </div>
                            </div>
                            <div class="col-xs-16 col-lg-6">
                                <div class="d-flex flex-column align-items-end" style="gap: 5px; padding: 12.5px 15px 12.5px 15px">
                                    <div class="d-flex" style="gap: 5px; white-space: nowrap">
                                        <Popper hover arrow style="margin: 0; border: 0">
                                            <template #content>
                                                <div>{{ $t('views.inventoryStatus.inventorySummary.tooltip.sellable') }} {{ getTargetCurrencyFormat(stats.expected?.expected_profit?.sellable) }}</div>
                                                <div>{{ $t('views.inventoryStatus.inventorySummary.tooltip.inbound') }} {{ getTargetCurrencyFormat(stats.expected?.expected_profit?.inbound) }}</div>
                                                <div>{{ $t('views.inventoryStatus.inventorySummary.tooltip.reserved') }} {{ getTargetCurrencyFormat(stats.expected?.expected_profit?.reserved) }}</div>
                                            </template>
                                            <span style="font-size: 12px; font-weight: 400; line-height: 21px; color: #677788">{{ $t('views.inventoryStatus.sections.expectedProfit.title') }}</span>
                                        </Popper>
                                        <InfoTooltip :content="$t('views.inventoryStatus.sections.expectedProfit.tooltip')" />
                                    </div>
                                    <span class="fs-18" style="font-weight: 700; line-height: 21px; color: #555; white-space: nowrap">{{ getTargetCurrencyFormat(stats.expected?.expected_profit?.total) }}</span>
                                </div>
                            </div>
                            <div class="col-xs-16 col-lg-6">
                                <div class="d-flex flex-column" style="gap: 5px; padding: 12.5px 15px 12.5px 15px">
                                    <div class="d-flex" style="gap: 5px; white-space: nowrap">
                                        <Popper hover arrow style="margin: 0; border: 0">
                                            <template #content>
                                                <div>{{ $t('views.inventoryStatus.inventorySummary.tooltip.sellable') }} {{ getTargetCurrencyFormat(stats.expected?.min_expected_profit?.sellable) }}</div>
                                                <div>{{ $t('views.inventoryStatus.inventorySummary.tooltip.inbound') }} {{ getTargetCurrencyFormat(stats.expected?.min_expected_profit?.inbound) }}</div>
                                                <div>{{ $t('views.inventoryStatus.inventorySummary.tooltip.reserved') }} {{ getTargetCurrencyFormat(stats.expected?.min_expected_profit?.reserved) }}</div>
                                            </template>
                                            <span style="font-size: 12px; font-weight: 400; line-height: 21px; color: #677788">{{ $t('views.inventoryStatus.sections.minExpectedProfit.title') }}</span>
                                        </Popper>
                                        <InfoTooltip :content="$t('views.inventoryStatus.sections.minExpectedProfit.tooltip')" />
                                    </div>
                                    <span class="fs-18" style="font-weight: 700; line-height: 21px; color: #555; white-space: nowrap">{{ getTargetCurrencyFormat(stats.expected?.min_expected_profit?.total) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mb-5 grid-gap-2 sm-flex-column">
            <div class="col-xs-16 col-lg-4 sm-mb-5">
                <div class="card">
                    <div class="card-header d-flex align-items-center" style="height: 79px; font-weight: 500; font-size: 15px">{{ $t('views.inventoryStatus.withoutCog.title') }}</div>
                    <div class="card-body card-body-height" style="height: 445px" @scroll="handleScroll">
                        <div v-if="withoutCog.item_count === 0" style="height: 100%; display: grid; place-items: center">
                            <div>
                                <strong>{{ $t('views.inventoryStatus.withoutCog.noItems.header') }}</strong>
                                <p>{{ $t('views.inventoryStatus.withoutCog.noItems.content') }}</p>
                                <div class="text-right mt-5">
                                    <img src="@/assets/img/1.png" height="200" />
                                </div>
                            </div>
                        </div>
                        <template v-else>
                            <div class="alert alert-soft-danger p-0 d-flex" role="alert">
                                <div class="flex-shrink-0 bg-danger text-white d-flex align-items-center" style="width: 75px; padding: 20px; border-top-left-radius: 5px; border-bottom-left-radius: 5px">
                                    <i class="bi bi-upc-scan text-white" style="font-size: 35px"></i>
                                </div>
                                <div class="flex-grow-1 ms-2" style="padding: 20px">
                                    <div class="d-flex flex-column" style="margin-bottom: 5px">
                                        <span style="font-weight: 700; font-size: 15px; color: #00203f">{{ $t('views.inventoryStatus.withoutCog.alert.title', { count: withoutCog.total }) }}</span>
                                        <span style="font-weight: 400; font-size: 12px; color: #677788">{{ $t('views.inventoryStatus.withoutCog.alert.content') }}</span>
                                    </div>
                                    <button type="button" class="btn btn-link btn-sm p-0 text-danger" @click="redirectToInventory">{{ $t('views.inventoryStatus.withoutCog.alert.button') }} <i class="bi-chevron-right"></i></button>
                                </div>
                            </div>
                            <table class="table table-sticky table-thead-bordered table-align-middle modal-table">
                                <thead class="thead-light">
                                    <tr>
                                        <th>{{ $t('views.inventoryStatus.withoutCog.columns.image') }}</th>
                                        <th>{{ $t('views.inventoryStatus.withoutCog.columns.productInfo') }}</th>
                                        <th>{{ $t('views.inventoryStatus.withoutCog.columns.cog') }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in withoutCog.data" :key="item.id" class="bg-white">
                                        <td class="text-center" style="max-width: 60px">
                                            <ImagePlaceholder :img_url="item.img_url" style="height: 48px" />
                                        </td>
                                        <td>
                                            <div class="d-flex flex-column">
                                                <Popper class="popp" hover arrow>
                                                    <template #content>{{ item.title }}</template>
                                                    <div class="text-ellipsis" style="max-width: 175px">{{ item.title }}</div>
                                                </Popper>
                                                <div class="d-flex" style="gap: 5px">
                                                    <span>ASIN:</span>
                                                    <InventoryClipboard :asin="item.asin" />
                                                </div>
                                                <div class="d-flex" style="gap: 5px">
                                                    <span>SKU:</span>
                                                    <InventoryClipboard type="sku" :asin="item.asin" :sku="item.sku" />
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="input-group d-flex" style="height: 37px">
                                                <CurrencyInput v-model="item.cost_of_goods" class="sm-input form-control" style="max-height: 37px" @focus="() => (storeCOG = item.cost_of_goods)" @blur="updateCost(item.id, item.cost_of_goods)" />
                                                <span class="input-group-text" style="background-color: #fff !important; max-height: 37px; font-size: 12px">{{ stats.sourceCurrency }}</span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div v-if="withoutCog.item_count === 0" style="height: 235px; display: grid; place-items: center">
                                <div class="alert alert-soft-primary" role="alert">{{ $t('common.noProduct') }}</div>
                            </div>

                            <div v-if="withoutCog.last_page > pagination.withoutCog.page" class="d-flex justify-content-center my-2">
                                <button class="btn btn-sm btn-primary d-flex align-items-center" @click="pagination.withoutCog.page++" :disabled="withoutCogLoading" style="gap: 5px">
                                    <div v-if="withoutCogLoading" class="spinner-border spinner-border-sm" role="status"></div>
                                    <span>{{ $t('common.loadMore') }}</span>
                                </button>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-xs-16 col-lg-5 sm-mb-5">
                <div class="card">
                    <div class="card-header d-flex align-items-center" style="height: 79px">
                        <div class="d-flex align-items-center justify-content-between w-100">
                            <span style="font-weight: 500; font-size: 15px">{{ $t('views.inventoryStatus.ordersSummary.title') }}</span>
                            <button type="button" class="btn btn-link btn-sm p-0 text-primary text-decoration-underline" style="font-size: 11.9px; font-weight: 600" @click="$router.push({ name: 'orders' })">
                                {{ $t('views.inventoryStatus.ordersSummary.viewAll') }}
                            </button>
                        </div>
                    </div>
                    <div class="card-body card-body-height" style="height: 445px" @scroll="handleScroll">
                        <table class="table table-sticky table-thead-bordered table-align-middle modal-table">
                            <thead class="thead-light">
                                <tr>
                                    <th></th>
                                    <th>{{ $t('views.inventoryStatus.ordersSummary.columns.totalOrderAmount') }}</th>
                                    <th>{{ $t('views.inventoryStatus.ordersSummary.columns.profit') }}</th>
                                    <th>{{ $t('views.inventoryStatus.ordersSummary.columns.roi') }}</th>
                                    <th>{{ $t('views.inventoryStatus.ordersSummary.columns.totalOrderItemAmount') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in stats.ordersSummary" :key="item.id" class="bg-white">
                                    <td>{{ $t(`views.inventoryStatus.ordersSummary.periods.${item.period}`) }}</td>
                                    <td>
                                        {{ item.total_order_amount ? stats.targetCurrency : '' }} <span style="color: #00203f; font-weight: 700">{{ item.total_order_amount ? formatNumber(item.total_order_amount) : '-' }}</span>
                                    </td>
                                    <td>
                                        {{ item.total_profit ? stats.targetCurrency : '' }} <span style="color: #00203f; font-weight: 700">{{ item.total_profit ? formatNumber(item.total_profit) : '-' }}</span>
                                    </td>
                                    <td>{{ item.total_roi ? formatPercentage(item.total_roi) : '-' }}</td>
                                    <td>{{ item.total_order_item_amount ? item.total_order_item_amount : '-' }}</td>
                                </tr>
                            </tbody>
                        </table>

                        <div v-if="stats.ordersSummary?.length === 0" style="height: 375px; display: grid; place-items: center">
                            <div class="alert alert-soft-primary" role="alert">{{ $t('common.noData') }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-16 col-lg-3">
                <div class="card h-100">
                    <div class="card-header d-flex align-items-center" style="height: 79px; font-weight: 600; font-size: 15px">{{ $t('views.inventoryStatus.ordersByStatus.title') }}</div>
                    <div class="card-body">
                        <div class="d-flex justify-content-center">
                            <Doughnut :key="chartDoughnutKey" :data="chartDoughnutData" :options="chartDoughnutOptions" style="height: 178px" />
                            <div class="d-flex flex-column align-items-center justify-content-center chartjs-doughnut-custom-stat" style="top: 175px">
                                <span style="font-size: 24px; font-weight: 700; line-height: 21px">{{ stats.ordersByStatus?.total }}</span>
                                <span style="font-size: 15px; font-weight: 500; line-height: 21px; color: #677788">{{ $t('views.inventoryStatus.ordersByStatus.total') }}</span>
                            </div>
                        </div>
                        <div style="border-top: 0.6px solid #e7eaf3; margin-top: 30px; margin-bottom: 30px"></div>
                        <div class="row">
                            <div class="col-6">
                                <div class="d-flex align-items-start" style="gap: 10px">
                                    <div class="bg-soft-primary text-primary" style="border-radius: 50%; flex: 0">
                                        <span class="avatar-initials"><i class="bi-clock-fill" style="font-size: 24px"></i></span>
                                    </div>
                                    <div class="d-flex flex-column align-items-start">
                                        <Popper hover arrow>
                                            <template #content>{{ $t('views.inventoryStatus.ordersByStatus.pending.tooltip') }}</template>
                                            <span style="color: #677788">{{ $t('views.inventoryStatus.ordersByStatus.pending.title') }}</span>
                                        </Popper>
                                        <span style="font-size: 22px; font-weight: 600; margin-top: 10px">{{ stats.ordersByStatus?.pending }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="d-flex align-items-start" style="gap: 10px">
                                    <div class="bg-soft-success text-success" style="border-radius: 50%; flex: 0">
                                        <span class="avatar-initials"><i class="bi-check-circle-fill" style="font-size: 24px"></i></span>
                                    </div>
                                    <div class="d-flex flex-column align-items-start">
                                        <Popper hover arrow>
                                            <template #content>{{ $t('views.inventoryStatus.ordersByStatus.completed.tooltip') }}</template>
                                            <span style="color: #677788">{{ $t('views.inventoryStatus.ordersByStatus.completed.title') }}</span>
                                        </Popper>
                                        <span style="font-size: 22px; font-weight: 600; margin-top: 10px">{{ stats.ordersByStatus?.completed }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6" style="margin-top: 20px">
                                <div class="d-flex align-items-start" style="gap: 10px">
                                    <div class="bg-soft-dark text-dark" style="border-radius: 50%; flex: 0">
                                        <span class="avatar-initials"><i class="bi-bag-x-fill" style="font-size: 24px"></i></span>
                                    </div>
                                    <div class="d-flex flex-column align-items-start">
                                        <Popper hover arrow>
                                            <template #content>{{ $t('views.inventoryStatus.ordersByStatus.canceled.tooltip') }}</template>
                                            <span style="color: #677788">{{ $t('views.inventoryStatus.ordersByStatus.canceled.title') }}</span>
                                        </Popper>
                                        <span style="font-size: 22px; font-weight: 600; margin-top: 10px">{{ stats.ordersByStatus?.canceled }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6" style="margin-top: 20px">
                                <div class="d-flex align-items-start" style="gap: 10px">
                                    <div class="bg-soft-danger text-danger" style="border-radius: 50%; flex: 0">
                                        <span class="avatar-initials"><i class="bi-arrow-counterclockwise" style="font-size: 24px"></i></span>
                                    </div>
                                    <div class="d-flex flex-column align-items-start">
                                        <Popper hover arrow>
                                            <template #content>{{ $t('views.inventoryStatus.ordersByStatus.refunded.tooltip') }}</template>
                                            <span style="color: #677788">{{ $t('views.inventoryStatus.ordersByStatus.refunded.title') }}</span>
                                        </Popper>
                                        <span style="font-size: 22px; font-weight: 600; margin-top: 10px">{{ stats.ordersByStatus?.refunded }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row grid-gap-2 mb-5">
            <div class="col-xs-16 col-lg-6 sm-mb-5">
                <div class="card">
                    <div class="card-header d-flex align-items-center" style="height: 79px; font-weight: 500; font-size: 15px">{{ $t('views.inventoryStatus.inventoryInvestmentDistribution.title') }}</div>
                    <div class="card-body card-body-height" style="height: 445px" @scroll="handleScroll">
                        <table class="table table-sticky table-thead-bordered table-align-middle modal-table">
                            <thead class="thead-light">
                                <tr>
                                    <th>{{ $t('views.inventoryStatus.inventoryInvestmentDistribution.columns.image') }}</th>
                                    <th>{{ $t('views.inventoryStatus.inventoryInvestmentDistribution.columns.productInfo') }}</th>
                                    <th>{{ $t('views.inventoryStatus.inventoryInvestmentDistribution.columns.percent') }}</th>
                                    <th>{{ $t('views.inventoryStatus.inventoryInvestmentDistribution.columns.salesAcceleration') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in salesVelocity.data" :key="item.asin" class="bg-white">
                                    <td class="text-center" style="max-width: 48px">
                                        <ImagePlaceholder :img_url="item.img_url" style="height: 48px" />
                                    </td>
                                    <td>
                                        <div class="d-flex flex-column">
                                            <Popper class="popp" hover arrow>
                                                <template #content>{{ item.title }}</template>
                                                <div class="text-ellipsis" style="max-width: 300px">{{ item.title }}</div>
                                            </Popper>
                                            <div class="d-flex" style="gap: 5px">
                                                <span>ASIN:</span>
                                                <InventoryClipboard :asin="item?.asin" />
                                            </div>
                                            <div class="d-flex" style="gap: 5px">
                                                <span>SKU:</span>
                                                <InventoryClipboard type="sku" :asin="item?.asin" :sku="item.sku" />
                                            </div>
                                        </div>
                                    </td>
                                    <td :class="isHyphenClass(item.stock_percentage)">{{ item.stock_percentage ? formatPercentage(item.stock_percentage) : '-' }}</td>
                                    <td>
                                        <template v-if="item.days_in_inventory">{{ formatNumber(item.sales_velocity) }}/{{ $t('views.inventoryStatus.inventoryInvestmentDistribution.day') }}</template>
                                        <template v-else>{{ formatPercentage(item.sales_velocity) }}</template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div v-if="salesVelocity.last_page > pagination.salesVelocity.page" class="d-flex justify-content-center my-2">
                            <button class="btn btn-sm btn-primary d-flex align-items-center" @click="pagination.salesVelocity.page++" :disabled="salesVelocityLoading" style="gap: 5px">
                                <div v-if="salesVelocityLoading" class="spinner-border spinner-border-sm" role="status"></div>
                                <span>{{ $t('common.loadMore') }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-16 col-lg-6">
                <div class="card">
                    <div class="card-header d-flex align-items-center" style="height: 79px">
                        <span style="font-weight: 500; font-size: 15px"
                            >{{ $t('views.inventoryStatus.geographicalDistributionOfOrders.title') }} <template v-if="currentShortcut">({{ $t('views.inventoryStatus.daysShortcuts.' + currentShortcut) }})</template
                            ><template v-else>({{ moment(date_range.startDate).format('DD.MM.YYYY') }} - {{ moment(date_range.endDate).format('DD.MM.YYYY') }})</template></span
                        >
                    </div>
                    <div class="card-body card-body-height" style="height: 445px" @scroll="handleScroll">
                        <table class="table table-sticky table-thead-bordered table-align-middle modal-table">
                            <thead class="thead-light">
                                <tr>
                                    <th>{{ $t('views.inventoryStatus.geographicalDistributionOfOrders.columns.state') }}</th>
                                    <th>{{ $t('views.inventoryStatus.geographicalDistributionOfOrders.columns.uniquePostalCode') }}</th>
                                    <th>{{ $t('views.inventoryStatus.geographicalDistributionOfOrders.columns.order') }}</th>
                                    <th>{{ $t('views.inventoryStatus.geographicalDistributionOfOrders.columns.refunds') }}</th>
                                    <th>{{ $t('views.inventoryStatus.geographicalDistributionOfOrders.columns.estimatedProfit') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in locationStats.data" :key="index" class="bg-white">
                                    <td>{{ item.state ? item.state : '-' }}</td>
                                    <td>{{ item.unique_postal_codes }}</td>
                                    <td>{{ item.total_orders }}</td>
                                    <td>{{ item.total_refund }}</td>
                                    <td :class="isHyphenClass(item.roi_percentage)">{{ formatPercentage(item.roi_percentage) }}</td>
                                </tr>
                            </tbody>
                        </table>

                        <div v-if="locationStats.last_page > pagination.locationStats.page" class="d-flex justify-content-center my-2">
                            <button class="btn btn-sm btn-primary d-flex align-items-center" @click="pagination.locationStats.page++" :disabled="locationStatsLoading" style="gap: 5px">
                                <div v-if="locationStatsLoading" class="spinner-border spinner-border-sm" role="status"></div>
                                <span>{{ $t('common.loadMore') }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row grid-gap-2" style="margin-bottom: 100px">
            <div class="col-xs-16 col-lg-7 sm-mb-5">
                <div class="card">
                    <div class="card-header d-flex align-items-center" style="height: 79px; font-weight: 500; font-size: 15px">{{ $t('views.inventoryStatus.bestSellers.title') }}</div>
                    <div class="card-body card-body-height" style="height: 445px" @scroll="handleScroll">
                        <table class="table table-sticky table-thead-bordered table-align-middle modal-table">
                            <thead class="thead-light">
                                <tr>
                                    <th>{{ $t('views.inventoryStatus.bestSellers.columns.image') }}</th>
                                    <th>{{ $t('views.inventoryStatus.bestSellers.columns.productInfo') }}</th>
                                    <th>{{ $t('views.inventoryStatus.bestSellers.columns.totalQuantity') }}</th>
                                    <th>{{ $t('views.inventoryStatus.bestSellers.columns.totalOrders') }}</th>
                                    <th>{{ $t('views.inventoryStatus.bestSellers.columns.profitRoi') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in bestSellers" :key="item.asin" class="bg-white">
                                    <td class="text-center" style="max-width: 48px">
                                        <ImagePlaceholder :img_url="item.img_url" style="height: 48px" />
                                    </td>
                                    <td>
                                        <div class="d-flex flex-column">
                                            <Popper class="popp" hover arrow>
                                                <template #content>{{ item.title }}</template>
                                                <div class="text-ellipsis" style="max-width: 350px">{{ item.title }}</div>
                                            </Popper>
                                            <div class="d-flex" style="gap: 5px">
                                                <span>ASIN:</span>
                                                <InventoryClipboard :asin="item.asin" />
                                            </div>
                                            <div class="d-flex" style="gap: 5px">
                                                <span>SKU:</span>
                                                <InventoryClipboard type="sku" :asin="item.asin" :sku="item.sku" />
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <template v-if="item.total_quantity">{{ item.total_quantity }}</template
                                        ><span v-else class="badge bg-soft-danger text-danger">{{ $t('views.inventoryStatus.bestSellers.noStock') }}</span>
                                    </td>
                                    <td>{{ item.total_orders }}</td>
                                    <td>
                                        <div class="d-flex flex-column">
                                            <span>
                                                {{ item.profit ? stats.targetCurrency : '' }} <span style="color: #00203f; font-weight: 700">{{ formatNumber(item.profit) }}</span>
                                            </span>
                                            <span :class="item.roi === 0 ? 'text-secondary' : item.roi > 0 ? 'text-success' : 'text-danger'"
                                                ><i :class="item.roi > 0 ? 'bi-graph-up' : 'bi-graph-down'"></i> {{ formatPercentage(item.roi ? item.roi : 0) }}</span
                                            >
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div v-if="bestSellers.length === 0" style="height: 375px; display: grid; place-items: center">
                            <div class="alert alert-soft-primary" role="alert">{{ $t('common.noProduct') }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-16 col-lg-5">
                <div class="card">
                    <div class="card-header d-flex align-items-center" style="height: 79px">
                        <div class="d-flex align-items-center justify-content-between w-100">
                            <span style="font-weight: 500; font-size: 15px">{{ $t('views.inventoryStatus.outOfStock.title') }}</span>
                            <button type="button" class="btn btn-link p-0 text-primary text-decoration-underline" style="font-size: 11.9px; font-weight: 600" :disabled="selectedRows.length === 0" @click="confirmSendToScan">
                                {{ $t('views.inventoryStatus.outOfStock.sendToScan') }}
                            </button>
                        </div>
                    </div>
                    <div class="card-body card-body-height" style="height: 445px" @scroll="handleScroll">
                        <table class="table table-sticky table-thead-bordered table-align-middle modal-table">
                            <thead class="thead-light">
                                <tr>
                                    <th class="table-checkbox" style="width: 25px">
                                        <input class="form-check-input" type="checkbox" :checked="selectedRows.length === outOfStock.length && selectedRows.length > 0" @change="selectAllOutOfStockProduct" />
                                    </th>
                                    <th>{{ $t('views.inventoryStatus.outOfStock.columns.image') }}</th>
                                    <th>{{ $t('views.inventoryStatus.outOfStock.columns.productInfo') }}</th>
                                    <th>{{ $t('views.inventoryStatus.outOfStock.columns.quantity') }}</th>
                                    <th>{{ $t('views.inventoryStatus.outOfStock.columns.cog') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in outOfStock.data" :key="item.id" class="bg-white">
                                    <td class="table-checkbox" style="width: 25px">
                                        <input :value="item.id" :checked="selectedRows.indexOf(item.id) > -1" @change="selectRow(item.id)" class="form-check-input" type="checkbox" />
                                    </td>
                                    <td class="text-center" style="max-width: 60px">
                                        <ImagePlaceholder :img_url="item.img_url" style="height: 48px" />
                                    </td>
                                    <td style="min-width: 150px">
                                        <div class="d-flex flex-column">
                                            <Popper class="popp" hover arrow>
                                                <template #content>{{ item.title }}</template>
                                                <div class="text-ellipsis" style="max-width: 150px">{{ item.title }}</div>
                                            </Popper>
                                            <div class="d-flex" style="gap: 5px">
                                                <span>ASIN:</span>
                                                <InventoryClipboard :asin="item.asin" />
                                            </div>
                                            <div class="d-flex" style="gap: 5px">
                                                <span>SKU:</span>
                                                <InventoryClipboard type="sku" :asin="item.asin" :sku="item.sku" />
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <Popper class="light-popper" placement="bottom" hover arrow>
                                            <template v-if="item.inbound_quantity > 0" #content>
                                                <div class="d-flex flex-column p-1" style="width: 125px">
                                                    <div class="d-flex align-items-center justify-content-between mb-2">
                                                        <span>Shipped:</span>
                                                        <span class="text-right">{{ item.quantity_details?.inbound_shipped_quantity || 0 }}</span>
                                                    </div>
                                                    <div class="d-flex align-items-center justify-content-between mb-2">
                                                        <span>Working:</span>
                                                        <span class="text-right">{{ item.quantity_details?.inbound_working_quantity || 0 }}</span>
                                                    </div>
                                                    <div class="d-flex align-items-center justify-content-between">
                                                        <span>Receiving:</span>
                                                        <span class="text-right">{{ item.quantity_details?.inbound_receiving_quantity || 0 }}</span>
                                                    </div>
                                                </div></template
                                            >{{ item.inbound_quantity || 0 }}</Popper
                                        >
                                    </td>
                                    <td>
                                        {{ item.expected_cog ? item.expected_cog.currency : '' }} <span style="color: #00203f; font-weight: 700">{{ item.expected_cog ? formatNumber(item.expected_cog.total) : '-' }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div v-if="outOfStock.item_count === 0" style="height: 375px; display: grid; place-items: center">
                            <div class="alert alert-soft-primary" role="alert">{{ $t('common.noProduct') }}</div>
                        </div>

                        <div v-if="outOfStock.last_page > pagination.outOfStock.page" class="d-flex justify-content-center my-2">
                            <button class="btn btn-sm btn-primary d-flex align-items-center" @click="pagination.outOfStock.page++" :disabled="outOfStockLoading" style="gap: 5px">
                                <div v-if="outOfStockLoading" class="spinner-border spinner-border-sm" role="status"></div>
                                <span>{{ $t('common.loadMore') }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DateRangePicker from '@/components/DateRangePicker.vue'
import '@vuepic/vue-datepicker/dist/main.css'
import moment from 'moment'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ArcElement } from 'chart.js'
import { Bar as ChartBar, Doughnut, Line as ChartLine } from 'vue-chartjs'
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
import InventoryClipboard from '@/components/Inventory/InventoryClipboard.vue'
import CurrencyInput from '@/components/CurrencyInput.vue'
import { formatCurrency, formatPercentage } from '@/utils/format-number'
import { countryInfo } from '@/utils/helper'
import ImagePlaceholder from '@/components/Inventory/ImagePlaceholder.vue'
import InventoryStatusCalculator from '@/components/Inventory/InventoryStatusCalculator.vue'
import InfoTooltip from '@/components/Variations/InfoTooltip.vue'

moment.utc()

const countries = countryInfo()

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement)

export default {
    name: 'InventoryStatus',
    components: { DateRangePicker, ChartBar, Doughnut, ChartLine, InventoryClipboard, CurrencyInput, ImagePlaceholder, InventoryStatusCalculator, InfoTooltip },
    data: function () {
        return {
            moment,
            formatCurrency,
            formatPercentage,
            syncStates: [
                'INITIAL',
                'INVENTORY_SYNC_STARTED',
                'INVENTORY_SYNC_COMPLETED',
                'FEE_REPORT_COMPLETED',
                'RECENT_ORDERS_SYNC_STARTED',
                'RECENT_ORDERS_SYNC_COMPLETED',
                'HISTORICAL_ORDERS_SYNC_STARTED',
                'HISTORICAL_ORDERS_SYNC_COMPLETED',
                'SYNC_COMPLETED',
            ],
            date_range: {
                startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
                endDate: moment().format('YYYY-MM-DD'),
            },
            storeCOG: '',
            selectedRows: [],
            currentShortcut: 'thisWeek',
            daysShortcuts: ['today', 'thisWeek', 'thisMonth', 'pastMonth', 'thisYear'],
            withoutCogLoading: false,
            outOfStockLoading: false,
            locationStatsLoading: false,
            salesVelocityLoading: false,
            pagination: {
                withoutCog: {
                    page: 1,
                },
                outOfStock: {
                    page: 1,
                },
                locationStats: {
                    page: 1,
                    dateRange: '',
                },
                salesVelocity: {
                    page: 1,
                },
            },
            chartBarKey: 0,
            chartBarData: {
                labels: [],
                datasets: [
                    {
                        label: this.$t('views.inventoryStatus.orderChart.profit'),
                        data: [],
                        backgroundColor: '#ffb53e',
                        hoverBackgroundColor: '#ffb53e',
                        borderColor: '#ffb53e',
                        maxBarThickness: '10',
                        yAxisID: 'y1',
                    },
                    {
                        label: this.$t('views.inventoryStatus.orderChart.turnover'),
                        data: [],
                        backgroundColor: '#fdbe69',
                        borderColor: '#fdbe69',
                        maxBarThickness: '10',
                        yAxisID: 'y1',
                    },
                    {
                        label: this.$t('views.inventoryStatus.orderChart.orderAmount'),
                        data: [],
                        backgroundColor: '#fee9cd',
                        borderColor: '#fee9cd',
                        maxBarThickness: '10',
                        yAxisID: 'y2',
                    },
                ],
            },
            chartBarOptions: {
                responsive: true,
                maintainAspectRatio: false,
                fill: true,
                scales: {
                    y1: {
                        grid: {
                            color: '#e7eaf3',
                            drawBorder: false,
                            zeroLineColor: '#e7eaf3',
                        },
                        ticks: {
                            beginAtZero: true,
                            stepSize: 100,
                            fontSize: 12,
                            fontColor: '#97a4af',
                            fontFamily: 'Inter, sans-serif',
                            padding: 10,
                            postfix: '$',
                        },
                    },
                    y2: {
                        position: 'right',
                        ticks: {
                            beginAtZero: true,
                            stepSize: 1,
                            fontSize: 12,
                            fontColor: '#97a4af',
                            fontFamily: 'Inter, sans-serif',
                            padding: 10,
                        },
                    },
                    x: {
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                        ticks: {
                            font: {
                                size: 12,
                                family: 'Inter, sans-serif',
                            },
                            color: '#97a4af',
                            padding: 5,
                            callback: function (value, index, ticks) {
                                const dateParts = this.getLabelForValue(value).split('.')
                                return `${dateParts[1]}.${dateParts[0]}.${dateParts[2]}`
                            },
                        },
                    },
                },
                plugins: {
                    tooltip: {
                        prefix: '$',
                        hasIndicator: true,
                        mode: 'index',
                        intersect: false,
                        callbacks: {
                            label: function (context) {
                                let value = context.raw
                                if (typeof value === 'number' && context.dataset.backgroundColor != '#fee9cd') {
                                    value = value.toFixed(2)
                                }
                                return `${context.dataset.label}: ${value}`
                            },
                            title: (tooltipItems) => {
                                const dateParts = tooltipItems[0].label.split('.')
                                return `${dateParts[1]}.${dateParts[0]}.${dateParts[2]}`
                            },
                        },
                    },
                    legend: {
                        align: 'end',
                        labels: {
                            pointStyle: 'circle',
                            pointStyleWidth: 15,
                            usePointStyle: true,
                        },
                    },
                },
                hover: {
                    mode: 'nearest',
                    intersect: true,
                },
            },
            chartDoughnutKey: 0,
            chartDoughnutData: {
                datasets: [
                    {
                        data: [],
                        backgroundColor: ['#ffb53e', '#00c9a7', '#00203f', '#ed4c78'],
                        borderWidth: 5,
                        hoverBorderColor: '#fff',
                    },
                ],
            },
            chartDoughnutOptions: {
                cutout: '80%',
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    tooltip: {
                        postfix: 'k',
                        hasIndicator: true,
                        mode: 'index',
                        intersect: true,
                        xAlign: 'right',
                        yAlign: 'center',
                        padding: 10,
                        callbacks: {
                            label: function (tooltipItem) {
                                let total = tooltipItem.dataset.data.reduce((a, b) => a + b, 0)
                                let percentage = ((tooltipItem.raw / total) * 100).toFixed(2)
                                if (total) {
                                    return `%${percentage}`
                                }
                                return undefined
                            },
                        },
                    },
                },
            },
        }
    },
    computed: {
        ...mapState('inventory', ['stats', 'outOfStock', 'bestSellers', 'withoutCog', 'locationStats', 'salesVelocity']),
        ...mapGetters('market', ['currentMarket']),
        sessionDateRange() {
            return sessionStorage.getItem('dateRange')
        },
    },
    created() {
        this.date = this.sessionDateRange ? [this.sessionDateRange.split(',')[0], this.sessionDateRange.split(',')[1]] : [new Date(new Date().setDate(new Date().getDate() - 7)), new Date()]
        this.pagination.locationStats.dateRange = `${this.date_range.startDate},${this.date_range.endDate}`
        this.getStats(`${this.date_range.startDate},${this.date_range.endDate}`).then(({ data }) => {
            this.changeLabelChart()
            this.chartBarData.labels = data.chart.map((item) => {
                const date = new Date(item.date)
                const month = date.getMonth() + 1
                const day = date.getDate()
                const year = date.getFullYear()
                return `${day}.${month}.${year}`
            })
            this.chartBarData.datasets[0].data = data.chart.map((item) => item.total_profit)
            this.chartBarData.datasets[1].data = data.chart.map((item) => item.total_order_amount)
            this.chartBarData.datasets[2].data = data.chart.map((item) => item.total_order_count)
            this.chartBarKey += 1
            this.chartDoughnutData.datasets[0].data = [data.ordersByStatus.pending, data.ordersByStatus.completed, data.ordersByStatus.canceled, data.ordersByStatus.refunded]
            this.chartDoughnutKey += 1
        })
        this.getOutOfStock(this.pagination.outOfStock)
        this.getBestSellers()
        this.getWithoutCog(this.pagination.withoutCog)
        this.getLocationStats({ payload: { ...this.pagination.locationStats, dateRange: `${this.date_range.startDate},${this.date_range.endDate}` } })
        this.getSalesVelocity(this.pagination.salesVelocity)
    },
    methods: {
        ...mapActions('inventory', ['getStats', 'getOutOfStock', 'getBestSellers', 'getWithoutCog', 'createExpenses', 'sendToScan', 'getLocationStats', 'getSalesVelocity']),
        ...mapMutations('inventory', ['SET_FILTER_OPTIONS', 'SET_FILTER_PARAMS', 'SET_SELECTED_FILTER_CARD', 'SET_CHART_KEY']),
        handleDate(data) {
            if (this.date_range.startDate != moment(data.startDate).format('YYYY-MM-DD') || this.date_range.endDate != moment(data.endDate).format('YYYY-MM-DD')) {
                this.currentShortcut = null
                this.date_range = {}
                this.date_range.startDate = moment(data.startDate).format('YYYY-MM-DD')
                this.date_range.endDate = moment(data.endDate).format('YYYY-MM-DD')
                sessionStorage.setItem('dateRange', `${this.date_range.startDate},${this.date_range.endDate}`)
                this.getStats(`${this.date_range.startDate},${this.date_range.endDate}`)
                this.getLocationStats({ payload: { ...this.pagination.locationStats, dateRange: `${this.date_range.startDate},${this.date_range.endDate}` } })
            }
        },
        formatNumber(number) {
            if (number === null || number === undefined) return null

            const factor = Math.pow(10, 2)
            const rounded = Math.floor(number * factor + 1e-9) / factor
            return rounded.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })
        },
        redirectToInventory() {
            this.SET_FILTER_OPTIONS({ key: 'noCostProducts', value: true })
            this.SET_FILTER_PARAMS({ key: 'filter_id', value: -3 })
            this.SET_SELECTED_FILTER_CARD({ id: -3 })
            this.$router.push({ name: 'inventory' })
        },
        getDiffIcon(rate) {
            if (rate > 0) {
                return 'bi-graph-up'
            }
            return 'bi-graph-down'
        },
        updateCost(inventoryId, value) {
            if (this.storeCOG !== value) {
                const payload = [{ amount: null, price: value, end_date: '' }]
                this.createExpenses({ id: inventoryId, payload }).then(() => {
                    this.getWithoutCog()
                })
            }
        },
        getTargetCurrencyFormat(price) {
            if (this.getCountryCodeByCurrency(this.stats?.targetCurrency)) {
                return formatCurrency(countries[this.getCountryCodeByCurrency(this.stats?.targetCurrency)]?.symbol, price || 0)
            }
        },
        getSourceCurrencyFormat(price) {
            if (this.getCountryCodeByCurrency(this.stats?.sourceCurrency)) {
                return formatCurrency(countries[this.getCountryCodeByCurrency(this.stats?.sourceCurrency)]?.symbol, price || 0)
            }
        },
        selectRow(id) {
            const index = this.selectedRows.indexOf(id)
            if (index > -1) {
                this.selectedRows.splice(index, 1)
            } else {
                this.selectedRows.push(id)
            }
        },
        selectAllOutOfStockProduct() {
            if (this.selectedRows.length === this.outOfStock.data.length) {
                this.selectedRows = []
                return
            }
            this.selectedRows = this.outOfStock.data.map((item) => item.id)
        },
        confirmSendToScan() {
            if (
                confirm(
                    this.$t('views.inventoryStatus.outOfStock.sendToScanConfirm', {
                        rows: this.selectedRows.length,
                        token: this.$tc('views.inventoryStatus.outOfStock.token', this.selectedRows.length),
                        product: this.$tc('views.inventoryStatus.outOfStock.product', this.selectedRows.length),
                    }),
                )
            ) {
                this.sendToScan({ ids: this.selectedRows }).then(() => {
                    this.selectedRows = []
                })
            }
        },
        getCountryCodeByCurrency(currency) {
            for (const countryCode in countries) {
                if (countries[countryCode].currency_text === currency) {
                    return countryCode
                }
            }
            return undefined
        },
        setDateRangShort(startDate, endDate) {
            this.date_range = {
                startDate: moment(startDate).format('YYYY-MM-DD'),
                endDate: moment(endDate).format('YYYY-MM-DD'),
            }
        },
        changeDateShortcut(day) {
            const today = moment().startOf('day').toDate()
            this.currentShortcut = day

            switch (day) {
                case 'today':
                    this.setDateRangShort(today, today)
                    break
                case 'thisWeek':
                    this.setDateRangShort(moment().subtract(6, 'days').toDate(), today)
                    break
                case 'thisMonth':
                    this.setDateRangShort(moment().startOf('month').toDate(), today)
                    break
                case 'pastMonth':
                    this.setDateRangShort(moment().subtract(1, 'month').startOf('month').toDate(), moment().subtract(1, 'month').endOf('month').toDate())

                    break
                case 'thisYear':
                    this.setDateRangShort(new Date(new Date().getFullYear(), 0, 1), today)
                    break
            }
        },
        handleScroll() {
            document.querySelectorAll('.popper').forEach((element) => {
                element.style.cssText = 'display: none !important'
            })
        },
        changeLabelChart() {
            this.chartBarData.datasets[0].label = this.$t('views.inventoryStatus.orderChart.profit', { currency: this.stats?.targetCurrency })
            this.chartBarData.datasets[1].label = this.$t('views.inventoryStatus.orderChart.turnover', { currency: this.stats?.targetCurrency })
            this.chartBarData.datasets[2].label = this.$t('views.inventoryStatus.orderChart.orderAmount')
            this.chartBarKey += 1
        },
        isHyphenClass(value) {
            if (!value) {
                return 'text-muted'
            } else if (value < 0) {
                return 'text-danger'
            }
            return 'text-success'
        },
    },
    watch: {
        date_range: {
            handler() {
                this.pagination.locationStats = {
                    page: 1,
                    dateRange: `${this.date_range.startDate},${this.date_range.endDate}`,
                }
                this.getStats(`${this.date_range.startDate},${this.date_range.endDate}`).then(({ data }) => {
                    this.chartBarData.labels = data.chart.map((item) => {
                        const date = new Date(item.date)
                        const month = date.getMonth() + 1
                        const day = date.getDate()
                        const year = date.getFullYear()
                        return `${day}.${month}.${year}`
                    })
                    this.chartBarData.datasets[0].data = data.chart.map((item) => item.total_profit)
                    this.chartBarData.datasets[1].data = data.chart.map((item) => item.total_order_amount)
                    this.chartBarData.datasets[2].data = data.chart.map((item) => item.total_order_count)
                    this.chartBarKey += 1
                    this.chartDoughnutData.datasets[0].data = [data.ordersByStatus.pending, data.ordersByStatus.completed, data.ordersByStatus.canceled, data.ordersByStatus.refunded]
                    this.chartDoughnutKey += 1
                })
                this.getLocationStats({ payload: this.pagination.locationStats })
            },
            deep: true,
        },
        'pagination.withoutCog': {
            deep: true,
            handler(data) {
                this.withoutCogLoading = true
                this.getWithoutCog(data).finally(() => {
                    this.withoutCogLoading = false
                })
            },
        },
        'pagination.outOfStock': {
            deep: true,
            handler(data) {
                this.outOfStockLoading = true
                this.getOutOfStock(data).finally(() => {
                    this.outOfStockLoading = false
                })
            },
        },
        'pagination.locationStats.page': function () {
            this.locationStatsLoading = true
            this.getLocationStats({ payload: this.pagination.locationStats, isFromLoadMore: true }).finally(() => {
                this.locationStatsLoading = false
            })
        },
        'pagination.salesVelocity': {
            deep: true,
            handler(data) {
                this.salesVelocityLoading = true
                this.getSalesVelocity(data).finally(() => {
                    this.salesVelocityLoading = false
                })
            },
        },
        '$i18n.locale': function () {
            this.changeLabelChart()
        },
    },
}
</script>

<style lang="scss" scoped>
.inventory-status {
    margin-top: 30px;

    h1 {
        font-weight: 500 !important;
        line-height: 21px;
        color: #00203f;
    }

    h2 {
        color: #555;
    }

    .summary-line-border {
        border-bottom: 1px solid #e7eaf3b2;
    }

    .summary-line {
        &:before {
            content: '';
            position: absolute;
            top: 100px;
            bottom: 15px;
            margin-left: -4px;
            border-left: 1px solid #e7eaf3b2;
        }
    }

    .border-line {
        &:before {
            content: '';
            position: absolute;
            top: 35px;
            bottom: 10px;
            margin-left: -20px;
            padding-left: 15px;
            border-left: 1px solid #e7eaf3b2;
        }
    }

    .modal-table {
        margin-bottom: 0 !important;
        border-radius: 5px;

        tbody {
            tr {
                td {
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 21px;
                    color: #677788;
                    height: 41px;
                    width: 170px;
                }
                td:first-child {
                    font-weight: 600;
                }
                td:nth-child(even) {
                    font-weight: 400;
                    color: #677788;
                }
            }
        }

        .text-ellipsis {
            font-size: 11.9px;
            font-weight: 400;
            line-height: 17.9px;
            color: #677788;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;

            &.title {
                max-width: 250px;
            }

            &.category {
                max-width: 125px;
            }
        }
        .dp__input_wrap {
            width: auto;
            > input {
                padding-inline-end: 12px !important;
                font-size: 14px;
                border: 0.6px solid #e7eaf3;
                color: #677788;
                width: 125px !important;
            }
        }
    }
}
.card {
    &-body {
        padding: 0.65625rem 1.3125rem;
    }
    &-title {
        font-size: 16px !important;
        line-height: 21px;
        margin: 5px 0px 15px 0px !important;
    }
    &-subtitle {
        font-size: 11px !important;
        font-weight: 400 !important;
        line-height: 21px;
        text-transform: none;
    }
    &-body-height {
        &::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        ::-webkit-scrollbar-thumb {
            background: #67778833;
        }
    }
}

.fs-18 {
    font-size: 18px !important;
}

.form-check-input {
    &:not(:checked):focus {
        border: 1px solid #11214399;
    }
}
.table-sticky thead {
    top: -11px !important;
}

.status-summary-row {
    padding: 30px 20px;
}

@media (width < 768px) {
    .status-summary-row {
        height: 100%;
        padding: 40px;

        .row > div {
            width: auto;
            height: 87px;
        }
    }
    .card-body-height {
        overflow: auto !important;
    }
    .sm-mb-5 {
        margin-bottom: 2rem !important;
    }
}

@media (481px <= width <= 767px) {
    .grid {
        display: grid;
        grid-template-columns: 1fr;

        &-gap-2 {
            gap: 2rem;
        }
    }
    .card-body-height {
        overflow: auto !important;
    }

    .fs-18 {
        font-size: 16px !important;
    }
}

@media (768px <= width <= 1024px) {
    .grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);

        &-gap-2 {
            gap: 2rem;
        }
    }
    .md-flex-column {
        display: flex;
        flex-direction: column;
        justify-content: flex-start !important;
        align-items: baseline !important;
        gap: 0.5rem;

        & > div {
            border: 0 !important;
        }
    }
}

@media (1025px <= width <= 1366px) {
    .grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
    }
}
</style>
